import styled from 'styled-components';

import Button from '~/components/User/Button';

export const CustomButtom = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
